import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_WS_URL, {
  autoConnect: false,
  path: process.env.NODE_ENV !== 'production' ? '/socket.io' : '/api/socket.io',
});

